import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CustomPagesService_GetPageLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/custom_pages/v1/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useCustomPageId} from './useCustomPageId';
import {usePreviewSessionId} from './usePreviewSessionId';

export const useCustomPageRequest = ({pageId}: {pageId?: number}) => {
  const pathPageId = useCustomPageId();
  const previewSessionId = usePreviewSessionId();
  const session = useFullSession();

  return useGrpcRequest(CustomPagesService_GetPageLazy, {
    pageId: pageId ?? pathPageId!,
    previewSessionId,
    session,
  });
};
